
// Generated with util/create-component.js
import React from 'react'

import { LoadingIconProps } from './LoadingIcon.types'

import './LoadingIcon.scss'
import { ArrowClockwise } from 'react-bootstrap-icons'

const LoadingIcon: React.FC<LoadingIconProps> = ({ 
  size,
  disabled,
  style
}) => {
  
  return (
    <ArrowClockwise
      className="spin" 
      size={size ?? 26} 
      style={{ 
        ...style,
        fill: disabled ? 'var(--slate10)' : 'var(--slate12)'
      }}
    />
  )
}

export default LoadingIcon  

